/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContainerForProductionOrderResponse } from '../../models/container-for-production-order-response';

export interface CreateDefaultContainersForProductionOrder$Params {
  externalProductionOrderId: string;
  numberOfAdditionalPallets?: number | null;
}

export function createDefaultContainersForProductionOrder(http: HttpClient, rootUrl: string, params: CreateDefaultContainersForProductionOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ContainerForProductionOrderResponse>> {
  const rb = new RequestBuilder(rootUrl, createDefaultContainersForProductionOrder.PATH, 'post');
  if (params) {
    rb.path('externalProductionOrderId', params.externalProductionOrderId, {});
    rb.query('numberOfAdditionalPallets', params.numberOfAdditionalPallets, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContainerForProductionOrderResponse>;
    })
  );
}

createDefaultContainersForProductionOrder.PATH = '/api/v1/PackLine/productionOrders/{externalProductionOrderId}/createDefaultContainers';
